import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import Skeleton from '@mui/material/Skeleton';
import useClasses from "../../useClasses";

const styles = (theme) => ({
  listItem: {
    borderRadius: theme.shape.borderRadius,
    width: "90%",
    margin: "auto",
  },
});

export default function ClientsSkeleton() {
  const classes = useClasses(styles);
  return (
    <List>
      {[0, 1, 2, 3, 4, 5, 6].map((index) => (
        <ListItem key={"ClientsSkeleton" + index} className={classes.listItem}>
          <ListItemIcon>
            <Skeleton variant="circular">
              <Avatar />
            </Skeleton>
          </ListItemIcon>
          <ListItemText>
            <Skeleton />
            <Skeleton />
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
}
